import { render } from "./friendsAccount.vue?vue&type=template&id=283d02da&scoped=true"
import script from "./friendsAccount.vue?vue&type=script&lang=js"
export * from "./friendsAccount.vue?vue&type=script&lang=js"

import "./friendsAccount.vue?vue&type=style&index=0&id=283d02da&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283d02da"]])

export default __exports__